document.addEventListener("change", (event) => {
  const target = (event as InputEvent).target as HTMLInputElement | null;
  if (target?.matches("[data-autosubmit]")) {
    target.form?.requestSubmit();
  }
}, false);
